import "./login.css";
import { Form, Input, Typography, Checkbox } from 'antd';
import logo from '@src/assets/img/wc-logo-big.png';
import { useState } from "react";
import { useNavigate } from "react-router-dom";


export const Login = ()=>{

    const [email, setEmail] = useState({value:'',error:''});
    const [remember, setRemember] = useState(false);


    const navigate = useNavigate();

    const handelEmail = (e)=>{
        const regex=/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
        if(e && regex.test(e)){
            
            setEmail({value: e?.toString(), error:''});
            sessionStorage.setItem('email', e?.toString());

        }else{
            setEmail({value: '', error:'Email is invalid'});
            sessionStorage.removeItem('email');
        }
    };



    return(

        <div className="login-parent-window">
            
            <div className='login-box'>
                <div className='login-form-container'>
                    <img src={logo} alt="" width={75} height={65}/>
                    
                    <Typography.Title level={3} className='text-center login-title' >Customer Login</Typography.Title>
                    
                    <div className="text">
                        to continue to report portal
                    </div>
                    <Form.Item style={{marginTop: '45px'}}>
                        <Input autoFocus placeholder='Email' className='generic-input-control'  onChange={(e)=>{handelEmail(e.target.value)}}/>
                        <div className="ant-form-text helper-text" style={{textAlign: 'left', marginTop: '5px', height:'15px'}}>{email?.error && email?.error}</div>
                        
                        <Form.Item className='validationCheckboxGroup' style={{textAlign:'left'}}>
                        
                            <Checkbox onChange={(e)=>setRemember(e.target.checked)}>
                                Remember me
                            </Checkbox>
                        </Form.Item>
                    </Form.Item>


                    <div className="login-btnGrp">
                        
                        <div className="forgetPassword" >Forget Email ?</div>
                       
                        <button 
                            disabled={
                                // !data?.checkUserByEmail?.response?.hasOwnProperty('_id') || 
                                email?.value?.length<1 || email?.error!==""}
                            className={
                                // !data?.checkUserByEmail?.response?.hasOwnProperty('_id') || 
                                email?.value?.length<1 || email?.error!==""? "drawer-filled-btn disabled-btn" : "drawer-filled-btn" } 
                            onClick={()=>navigate('/verify')}>
                            Next
                        </button>
                    </div>

                </div>

            </div>


        </div>
        
    )
};